import React, { useEffect, useState } from "react";
import { Col, FormGroup, Row } from "react-bootstrap";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Input, Label, Tooltip } from "reactstrap";

import toastr from "toastr";
import heic2any from "heic2any";
import Tiff from "tiff.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getPrinterByCountry,
  getPrinterList,
  postArtRequest,
  uploadArt,
} from "store/actions";
import { Oval } from "react-loader-spinner";

import { uploadFile } from "store/actions";

function UploadArt(props, args) {
  const location = useLocation();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const [pagename, setPageName] = useState();
  const [menu, menuopen] = useOutletContext();
  const [imageURLS, setImageURLs] = useState();
  const [isHeic, setIsHeic] = useState();
  const [images, setimages] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fileData, setFileData] = useState();
  const { user } = useSelector((state) => state?.Login);
  const { loading } = useSelector((state) => state?.art);
  const selector = useSelector((state) => state);
  const [loading2, setLoading2] = useState(false);
  const [DescCharCount, setDescCharCount] = useState(0);
  const [printerList, setPrinterList] = useState([]);

  const [fields, setFields] = useState({
    title: "",
    artist_name: "default",
    description: "",
    vertical_dimension: "",
    art_id: "",
    user_id: selector?.Login?.user?._id,
    printable_doc: "",
    printable_image_id: "",
    horizontal_dimension: "",
    size_type: "Centimeters",
    medium: "",
    color_options: "",
    type_of_surface: "",
    year: "",
    confirm: false,
    address: "",
    printer_id: "",
    physical_print: false,
    digital_print: false,
  });

  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(new Date().getFullYear());

  console.log("user data ", user);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get("pagename");

    console.log("QUERY PAGE:", page);

    if (page) {
      setPageName(page);
    }
  }, [location.search]);

  const [selectedValue, setSelectedValue] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedPrinterName, setSelectedPrinterName] = useState("");

  useEffect(() => {
    setYear(new Date().getFullYear());

    const printerListCallback = (res) => {
      if (res && res.success == true) {
        const printers = Array.isArray(res.data) ? res.data : [];

        setPrinterList(printers);

        // Auto-select the printer when only one printer is returned.
        if (printers.length === 1) {
          setFields((prev) => ({
            ...prev,
            printer_id: printers[0]?._id || "",
          }));

          setSelectedPrinterName(printers[0]?.shop_name || "");
          setSelectedValue(printers[0]?._id || "");
          setDropdownVisible(false);
        } else {
          setFields((prev) => ({
            ...prev,
            printer_id: "",
          }));

          setSelectedPrinterName("");
          setSelectedValue("");
          setDropdownVisible(printers.length > 1);
        }
      }
    };

    dispatch(getPrinterByCountry({}, printerListCallback));
  }, []);

  const callback = (response) => {
    const { status } = response;

    if (status === "success") {
      toastr.success("Your art has been submitted for approval successfully");

      if (pagename === "artSubmission") {
        // navigate("uploadArt", { state: dataToSend, artStatus:"pending"});
        navigate("/profile/art", { state: "pending" });
      } else {
        navigate("/profile/artworkproofing", { state: "pending" });
      }

      setimages([]);
      // settabs("pending")
    } else {
      toastr.error(response.message);
    }

    // setDisableSubmitButton(false)
    setLoading2(false);
  };

  console.log("user", user);

  const handleRadioChange = (event, id, name) => {
    setFields((p) => ({
      ...p,
      printer_id: id,
    }));

    setSelectedPrinterName(name);
    setSelectedValue(id);
    setDropdownVisible(false);
  };

  const uploadMultiFileSuccess = (name) => async (response) => {
    let imageData = {
      images: response.data._doc._id,
      user_id: selector?.Login?.user?._id,
      fileData,
      hash: response.data.hash,
      publicUrl: response.data.publicUrl,
      printable_image_id: fields.printable_image_id,
      artInfoData: fields,
      physical_print: fields?.physical_print ? true : false,
      digital_print: fields?.digital_print ? true : false,
      type: pagename,
    };

    dispatch(postArtRequest(imageData, callback));
  };

  const onChangeHandlerImage = (name) => async (e) => {
    let images = e.target.files;

    if (images.length < 1) return;

    for (let i = 0; i < images.length; i++) {
      const ext = images[i].name.split(".").pop().toLowerCase();

      if (
        ext !== "png" &&
        ext !== "jpg" &&
        ext !== "jpeg" &&
        ext !== "heic" &&
        ext !== "PNG" &&
        ext !== "JPG" &&
        ext !== "JPEG" &&
        ext !== "HEIC"
      ) {
        toastr.error(
          "Invalid file format. Please upload a JPG, JPEG, HEIC & PNG image."
        );

        return;
      }

      for (let i = 0; i < images.length; i++) {
        if (images[i] && images[i].size >= 50 * 1e7) {
          toastr.error(
            "File size exceeds the limit. Please choose a smaller image."
          );

          return false;
        }
      }

      if (ext === "heic") {
        setIsHeic(true);

        const blobfile = e.target.files[0];
        const blobURL = URL.createObjectURL(blobfile);
        const name = e.target.files[0].name.replace(/\s/g, "").split(".")[0];

        const resultBlob = await heic2any({
          blob: await (await fetch(blobURL)).blob(),
          toType: "image/jpg",
          quality: 1,
        });

        const converted_file = new File([resultBlob], name + ".jpg", {
          type: "image/jpeg",
          lastModified: new Date().getTime(),
        });

        const reader = new FileReader();

        reader.readAsDataURL(converted_file);

        reader.onload = (e) => {
          setImageURLs(e.target.result);
          setimages((prevImages) => prevImages.concat(converted_file));
        };
      } else {
        setimages((prevImages) => prevImages.concat(images[0]));

        const fileArray = Array.from(images).map((file) =>
          URL.createObjectURL(file)
        );

        setImageURLs(fileArray);
      }
    }
  };

  const onSubmit = async () => {
    if (images.length < 1) {
      toastr.error("No image selected. Please choose an image to upload.");
      return;
    }

    if (!fields.title) {
      return toastr.error("Title of Artwork is required!!");
    }

    if (!fields.description) {
      return toastr.error("Description is required!!");
    }

    if (!fields.vertical_dimension) {
      return toastr.error("Vertical Dimension is required!!");
    }

    if (!fields.horizontal_dimension) {
      return toastr.error("Horizontal dimension is required!!");
    }

    if (!fields.size_type) {
      return toastr.error("Size type is required!!");
    }

    if (!fields.medium) {
      return toastr.error("Medium is required!!");
    }

    if (!fields.color_options) {
      return toastr.error("Color option is required!!");
    }

    if (!fields.type_of_surface) {
      return toastr.error("Type of surface is required!!");
    }

    if (isNaN(Number(fields.year))) {
      return toastr.error("Invalid Year");
    } else if (Number(fields.year) > new Date().getFullYear()) {
      return toastr.error("Enter a valid year created");
    }

    if (!fields.year) {
      return toastr.error("Year is required!!");
    }

    if (!fields.printable_image_id && pagename === "artworkproofing") {
      return toastr.error("Please upload printable image.");
    }

    if (
      isNaN(Number(fields.year)) ||
      fields.year < 1900 ||
      fields.year > currentYear
    ) {
      return toastr.error(
        "Invalid Year. Please enter a year between 1900 and " + currentYear
      );
    } else if (Number(fields.year) > new Date().getFullYear()) {
      return toastr.error("Enter a valid year created");
    }

    if (!fields.address && pagename === "artworkproofing") {
      return toastr.error("Address is required!!");
    }

    if (!fields.printer_id && pagename === "artworkproofing") {
      return toastr.error("Select the print shop");
    }

    if (!fields.confirm) {
      return toastr.error("Please select checkbox for confirmation!!");
    }

    setLoading2(true);

    var formData = new FormData();
    const art = "art";

    formData.append("category", art);

    let lastimage = {};

    if (setIsHeic) {
      for (const key of Object.keys(images)) {
        lastimage = images[key];
      }
    } else {
      for (const x of images) {
        for (const key of Object.keys(images)) {
          lastimage = x[key];
        }
      }
    }

    formData.append("image", lastimage);

    dispatch(uploadArt(formData, uploadMultiFileSuccess("images")));
  };

  function deleteFile(e) {
    setImageURLs();
    setimages([]);
  }

  const inchToCm = (inch) => {
    if (!inch) return "";

    return (parseFloat(inch) * 2.54).toFixed(2);
  };

  const fieldsChangeHandler = async (name, value) => {
    if (name === "description") {
      setDescCharCount(value.length);
    }

    if (name === "year") {
      // Remove unwanted characters (+, -, e, .)
      value = value
        .split("")
        .filter((char) => char >= "0" && char <= "9")
        .join("");

      // Ensure the value doesn't exceed 4 digits
      value = value.slice(0, 4);
    }

    if (name === "vertical_dimension" || name === "horizontal_dimension") {
      value =
        user.artSizeUnit === "Inches"
          ? inchToCm(value)
          : value;
    }

    setFields((p) => ({
      ...p,
      [name]: value,
    }));
  };

  useEffect(() => {
    document.querySelectorAll("textarea").forEach((el) => {
      el.style.height = el.setAttribute(
        "style",
        "height: " + el.scrollHeight + "px"
      );

      el.classList.add("auto");

      el.addEventListener("input", (e) => {
        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
      });
    });
  }, []);

  const handlePrintType = (type, e) => {
    setFields((p) => ({
      ...p,
      [type]: e.target.checked,
    }));
  };

  console.log("pagename", pagename);

  // new changes logic start here --------------------------------------------------------------------------------------------

  const reUploadPrintable = () => {
    setFields((prevState) => ({
      ...prevState,
      printable_doc: "",
      printable_image_id: "",
    }));
  };

  const handleDocsChange = (name) => (evt) => {
    if (!evt) return;

    const docs = evt.target.files;

    if (docs.length === 0) return;

    const ext = docs[0].name.split(".").pop().toLowerCase();

    if (
      name === "printableImage" &&
      ![
        "tiff",
        "jpeg",
        "jpg",
        "JPG",
        "JPEG",
        "TIFF",
        "TIF",
        "tif",
      ].includes(ext)
    ) {
      return toastr.error(
        "Only JPG, JPEG, TIFF and TIF extensions are allowed"
      );
    }

    const file = docs[0];

    if (name === "printableImage") {
      const filename = file.name.replace(/\s/g, "");
      const removed_tiff = filename.split(".")[0];

      setFields((prevState) => ({
        ...prevState,
        printable_doc: removed_tiff,
      }));

      const uploadPrintableImageSuccess = (response) => {
        const { _id } = response.data;

        setFields((prev) => ({
          ...prev,
          printable_image_id: _id,
        }));

        toastr.success("Printable document has been uploaded successfully.");
      };

      dispatch(uploadFile({ image: file }, uploadPrintableImageSuccess));
    } else {
      // const uploadDocsSuccess = (response) => {
      //   const { _id, file_name } = response.data;
      //   setFields((prev) => ({
      //     ...prev,
      //     relatedImages: _id,
      //     docsName: file_name,
      //   }));
      //   toastr.success(
      //     "Additional support document has been uploaded successfully."
      //   );
      // };

      // dispatch(uploadFile({ image: file }, uploadDocsSuccess));
      // setFields((prevState) => ({
      //   ...prevState,
      //   docs_upload: file.name,
      // }));
    }
  };










  return (
    <>
      {(loading || loading2) && (
        <div className="loaderBoxMiane" style={{ zIndex: 10000 }}>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}

      <Row>
        <Col lg={12} className="mb-4">
          <h1>
            <i onClick={menuopen} className="fa-light fa-bars-sort"></i> Art
            Submission
          </h1>
        </Col>

        <Col lg={12}>
          <div className={"createCollection uploadFilecrete mb-4"}>
            <div className={`upload-btn-wrapper`}>
              {!!imageURLS ? (
                <div className="text-center uploadimgnew position-relative">
                  <img src={imageURLS} className="img-fluid" alt="" />

                  <div className="label-flex text-center">
                    <Label
                      htmlFor="inputGroupFile01"
                      className="label-style-file"
                    ></Label>
                  </div>

                  <button
                    className="upoadDocClose closebtnart"
                    onClick={() => deleteFile(imageURLS)}
                  >
                    <i class="fa-solid fa-circle-xmark"></i>
                  </button>
                </div>
              ) : (
                <div className="text-center uploadimgnew">
                  <input
                    name="image"
                    type="file"
                    hidden
                    id="inputGroupFile01"
                    onChange={onChangeHandlerImage("image")}
                    accept="image/*"
                  />

                  <div className="label-flex text-center">
                    <Label
                      htmlFor="inputGroupFile01"
                      className="label-style-file"
                    ></Label>
                  </div>

                  <div>
                    <Label
                      className="d-grid text-secondary cursor-pointer"
                      for="inputGroupFile01"
                    >
                      <i className="fa-sharp fa-light fa-file-arrow-up mb-3"></i>

                      {"UPLOAD FROM YOUR DEVICE"}
                    </Label>

                    <Tooltip
                      {...args}
                      isOpen={tooltipOpen}
                      target="TooltipExample"
                      toggle={toggle}
                      className="custom-tooltip"
                    >
                      Please upload the file you wish to use for your Digital
                      Artwork only and not the printable file used for print
                      shops. The print shop image file is uploaded when you
                      create your product and should be the highest resolution
                      file that the print shop has provided to you. For physical
                      only option, please submit the image for approval as if
                      you were doing an Digital image file. The image provided
                      by the print shop is uploaded when you create your
                      product.
                    </Tooltip>
                  </div>

                  <p className="mt-3 mb-3 text-center uploadimgText">
                    Allowed image format JPG, JPEG, HEIC & PNG. &nbsp;{" "}
                    <i id="TooltipExample" class="fa-solid fa-circle-info"></i>
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="createCollection">
            {pagename === "artworkproofing" && (
              <FormGroup className="form-group mb-4">
                <Label className="mb-1">Printable Format</Label>
                {fields?.printable_doc ? (
                  <div className="uploaddocs position-relative">
                    <Label
                      className="position-relative"
                      htmlFor="printableDocs"
                    >
                      <button
                        type="button"
                        onClick={reUploadPrintable}
                        className="upoadDocClose"
                      >
                        <i className="fa-solid fa-circle-xmark"></i>
                      </button>

                      <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                      &nbsp;{fields.printable_doc}
                    </Label>
                  </div>
                ) : (
                  <div className="uploaddocs">
                    <Input
                      className="d-none"
                      type="file"
                      name="printableImage"
                      id="printableDocs"
                      onChange={handleDocsChange("printableImage")}
                    />

                    <Label htmlFor="printableDocs">
                      <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                      &nbsp; UPLOAD FROM YOUR DEVICE
                    </Label>

                    <p className="pdecription mb-1 d-flex gap-2 align-items-center">
                      <i className="fa-regular fa-circle-exclamation"></i>

                      <span>
                        Upload the high quality file approved by your print shop
                        (JPG, JPEG, TIFF, and TIF format)
                      </span>
                    </p>
                    <p className="pdecription mb-1 d-flex gap-2 align-items-center">
                      <i className="fa-regular fa-circle-exclamation"></i>
                      <span>
                       Upload art with no border/frame, blank space, tilt or gaps.
                      </span>
                    </p>
                  </div>
                )}
              </FormGroup>
            )}

            <FormGroup className="form-group mb-4">
              <Label className="mb-1">Title of Artwork</Label>

              <div className="position-relative">
                <Input
                  type="text"
                  name="name"
                  maxLength="50"
                  value={fields?.name}
                  onChange={(e) =>
                    fieldsChangeHandler("title", e.target.value)
                  }
                  className="form-control bg-white "
                  placeholder="Enter the name of the artwork"
                />
              </div>
            </FormGroup>

            <FormGroup className="form-group mb-4 discription">
              <Label className="mb-1">Description</Label>

              <div className="position-relative">
                <Input
                  type="textarea"
                  name="description"
                  maxlength="2500"
                  onChange={(e) =>
                    fieldsChangeHandler("description", e.target.value)
                  }
                  className={"form-control pb-4 bg-white"}
                  placeholder="Provide a brief description of the artwork"
                />

                <div className="addresmsg position-absolute bottom-0 end-0">
                  {DescCharCount + "/2500"}
                </div>
              </div>

              <p className="pdecription mt-2">
                This description will be included a link to this URL on this Art
                detail page.
              </p>
            </FormGroup>

            <FormGroup className="form-group mb-4 discription">
              <Label className="mb-1">
                {pagename === "artworkproofing"
                  ? "Maximum Anticipated Reproduction Size"
                  : "Digital Artwork Size"}
              </Label>

              <Row>
                <Col lg={4}>
                  <Input
                    type="number"
                    name="description"
                    maxlength="50"
                    onChange={(e) =>
                      fieldsChangeHandler(
                        "vertical_dimension",
                        e.target.value
                      )
                    }
                    className={"form-control  bg-white"}
                    placeholder="Vertical Dimensions"
                  />
                </Col>

                <Col lg={4}>
                  <Input
                    type="number"
                    name="description"
                    maxlength="300"
                    onChange={(e) =>
                      fieldsChangeHandler(
                        "horizontal_dimension",
                        e.target.value
                      )
                    }
                    className={"form-control bg-white"}
                    placeholder="Horizontal Dimensions"
                  />
                </Col>

                <Col lg={4}>
                  <Input
                    type="text"
                    value={user.artSizeUnit}
                    readOnly
                    className="form-control bg-white"
                    placeholder="Size Type"
                  />
                </Col>
              </Row>
            </FormGroup>

            <Row>
              <Col lg={4}>
                <FormGroup className="form-group mb-4 discription">
                  <Label className="mb-1">Medium Used</Label>

                  <Input
                    type="select"
                    name="description"
                    maxlength="300"
                    onChange={(e) =>
                      fieldsChangeHandler("medium", e.target.value)
                    }
                    className={"form-control bg-white"}
                    placeholder="Horizontal Dimensions"
                  >
                    <option>--Select--</option>
                    <option>Oil</option>
                    <option>Acrylic</option>
                    <option>Watercolor</option>
                    <option>Pencil</option>
                    <option>Digital</option>
                    <option>Other</option>
                  </Input>
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="form-group mb-4 discription">
                  <Label className="mb-1">Color Options</Label>

                  <Input
                    type="select"
                    name="description"
                    maxlength="300"
                    onChange={(e) =>
                      fieldsChangeHandler("color_options", e.target.value)
                    }
                    className={"form-control bg-white"}
                    placeholder="Horizontal Dimensions"
                  >
                    <option>--Select--</option>
                    <option>Monochrome</option>
                    <option>Full Color</option>
                    <option>Pastels</option>
                    <option>Other</option>
                  </Input>
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="form-group mb-4 discription">
                  <Label className="mb-1">Type of Surface Used</Label>

                  <Input
                    type="select"
                    name="description"
                    maxlength="300"
                    onChange={(e) =>
                      fieldsChangeHandler("type_of_surface", e.target.value)
                    }
                    className={"form-control bg-white"}
                    placeholder="Horizontal Dimensions"
                  >
                    <option>--Select--</option>
                    <option>Canvas</option>
                    <option>Cold Press</option>
                    <option>Hot Press</option>
                    <option>Matte</option>
                    <option>Glossy</option>
                    <option>Paper</option>
                    <option>Other</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg={4}>
                <FormGroup className="form-group mb-4 discription">
                  <Label className="mb-1">Year Created</Label>

                  <Input
                    type="number"
                    name="year"
                    maxlength="4"
                    value={fields?.year}
                    onChange={(e) => {
                      fieldsChangeHandler("year", e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (["+", "-", "e"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    className={"form-control bg-white"}
                    placeholder="Enter the year artwork was created"
                  />
                </FormGroup>
              </Col>

              {/* {pagename != "artworkproofing" && (
                <>
                <Col lg={4}>
                <FormGroup className="form-group description">
                <Label className="mb-1">Type of product you wish to offer</Label>
                </FormGroup>
                  <Row>
                  <Col lg={6} >


                    <FormGroup className="form-group description">
                      <div className="CustomeCheckBox mt-3 ">
                        <input type="checkbox" id="digitalOnly" onClick={(e) => handlePrintType("digital_print", e)} />
                        <label htmlFor="digitalOnly"></label><span className="text-dark mb-0 cursor-pointer">
                          Digital Only
                        </span>
                      </div>
                    </FormGroup>
                    </Col>
                    <Col lg={6} >
                    <FormGroup className="form-group description">
                      <div className="CustomeCheckBox mt-3">
                        <input type="checkbox" id="physicalPrint" onClick={(e) => handlePrintType("physical_print", e)} />
                        <label htmlFor="physicalPrint"></label><span className="text-dark mb-0 cursor-pointer">
                          Physical Print
                        </span>
                      </div>
                    </FormGroup>
                    </Col>
                  </Row>
                </Col>
                 
                  </>
              )} */}
            </Row>

            {pagename === "artworkproofing" && (
              <Row>
                <Col lg={12}>
                  <FormGroup className="form-group mb-4 discription ">
                    <Label className="mb-1">Address</Label>

                    <Input
                      type="textarea"
                      name="Address"
                      value={fields?.address}
                      // value={fields?.description.replace(/\s+/g, ' ')}
                      onChange={(e) =>
                        fieldsChangeHandler("address", e.target.value)
                      }
                      className={"form-control bg-white"}
                      placeholder="Address"
                    />
                  </FormGroup>
                </Col>

                <Col lg={6}>
<FormGroup className="form-group mb-4 description customedrop dropdown-option">
  <Label className="mb-1">Print Shop</Label>

  {printerList.length > 1 ? (
    <Input
      type="select"
      name="printer_id"
      value={fields?.printer_id || ""}
      onChange={(e) => {
        const selectedPrinterId = e.target.value;

        const selectedPrinter = printerList.find(
          (item) => item?._id === selectedPrinterId
        );

        setFields((prev) => ({
          ...prev,
          printer_id: selectedPrinterId,
        }));

        setSelectedPrinterName(selectedPrinter?.shop_name || "");
        setSelectedValue(selectedPrinterId);
        setDropdownVisible(false);
      }}
      className="form-control form-select bg-white custom-input no-dropdown-icon"
    >
      <option value="">--Select--</option>

      {printerList.map((item) => (
        <option key={item?._id} value={item?._id}>
          {item?.shop_name}
        </option>
      ))}
    </Input>
  ) : (
    <Input
      type="text"
      value={
        printerList.length === 1
          ? selectedPrinterName
          : "--Select--"
      }
      className="form-control bg-white custom-input"
      readOnly
    />
  )}
</FormGroup>
                </Col>
              </Row>
            )}

            <FormGroup className="form-group mb-4 discription">
              <div className="CustomeCheckBox mb-2">
                <input
                  type="checkbox"
                  id="uploadart"
                  onChange={(e) =>
                    fieldsChangeHandler("confirm", e.target.checked)
                  }
                />{" "}

                <label htmlFor="uploadart"></label>

                <span className="text-dark mb-0 cursor-pointer">
                  I confirm this artwork was NOT created digitally using a
                  computer, iPad, software, artificial intelligence, or by other
                  electronic means, and is my originally created artwork.
                </span>
              </div>
            </FormGroup>

            <FormGroup>
              <div className="text-center Done-wrap">
                <FormGroup>
                  <div className="text-center Done-wrap">
                    <button
                      type={"submit"}
                      className="btn btn-secondary text-white fw-semibold px-5"
                      onClick={onSubmit}
                    >
                      {" "}
                      Submit
                    </button>
                  </div>
                </FormGroup>
              </div>
            </FormGroup>
          </div>
        </Col>
      </Row>
    </>
  );
}

UploadArt.args = {
  autohide: true,
  flip: true,
};

UploadArt.argTypes = {
  placement: {
    control: {
      type: "select",
    },
    options: ["top", "left", "right", "bottom"],
  },
};

export default UploadArt;